import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import colors from '@general/colors';

const FilterButton = ({ label, value, buttonClasses, attribute, onClick }) => {
    // e.g. Architecture/Design/Engineering > ARC04-Graphic Design
    const parts = label.split(' > ');
    let finalLabel = '';

    if (parts.length === 1) {
        finalLabel = parts[0];
    } else {
        // ARC04-Graphic Design - remove code
        const childLabelParts = parts[1].split('-');
        const childLabel = childLabelParts.length === 1 ? childLabelParts[0] : childLabelParts[1];
        finalLabel = `${parts[0]} > ${childLabel}`;
    }

    if (attribute === 'company_name') {
        finalLabel = `Company: ${finalLabel}`;
    } else if (attribute === 'minority_owned') {
        finalLabel = 'Minority Owned';
    } else if (attribute === 'woman_owned') {
        finalLabel = 'Woman Owned';
    }

    return (
        <li className="d-inline-block mr-2 mb-2">
            <button
                type="button"
                className={`d-flex align-items-top ${buttonClasses}`}
                style={styles.filterButton}
                // onClick={() => refine(value)}
                onClick={() => onClick(value)}
            >
                <span style={styles.filterButtonX}>
                    <FontAwesomeIcon icon={faTimes} />
                </span>
                <span className="ml-2 text-left">{finalLabel}</span>
            </button>
        </li>
    );
};

FilterButton.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.func.isRequired,
    buttonClasses: PropTypes.string,
    attribute: PropTypes.string,
    onClick: PropTypes.func,
};

const CurrentFilters = ({
    // Passed
    useButtons,
    buttonClasses = '',
    clearAllClasses = '',
    onClose,

    // Algolia
    items: facets,
    refine,
}) => {
    if (facets.length === 0) {
        return null;
    }

    const handleClick = value => {
        refine(value);
    };

    const filteredFacets = facets.filter(
        f => f.attribute !== 'events_attended' && f.attribute !== 'events_attended.code'
    );

    return (
        <div>
            <div className="mb-1">
                <ul className="list-inline mb-0">
                    {filteredFacets.map(facet => {
                        if (facet.items) {
                            return facet.items.map(filter => (
                                <FilterButton
                                    key={`${facet.id}-${filter.label}`}
                                    label={filter.label}
                                    value={filter.value}
                                    attribute={facet.attribute}
                                    buttonClasses={buttonClasses}
                                    onClick={handleClick}
                                />
                            ));
                        }

                        if (typeof facet.currentRefinement === 'string') {
                            return (
                                <FilterButton
                                    key={facet.id}
                                    label={facet.currentRefinement}
                                    value={facet.value}
                                    attribute={facet.attribute}
                                    buttonClasses={buttonClasses}
                                    onClick={handleClick}
                                />
                            );
                        }

                        return null;
                    })}
                </ul>
            </div>

            {!useButtons && filteredFacets.length > 0 && (
                <div>
                    <a className={clearAllClasses} style={styles.clearAllButton} onClick={() => refine(facets)}>
                        Clear All Filters
                    </a>
                </div>
            )}

            {useButtons && (
                <div style={styles.mobileButtonContainer}>
                    <button
                        type="button"
                        className="btn btn-tertiary mr-2"
                        style={styles.mobileButton}
                        onClick={() => onClose()}
                    >
                        Apply
                    </button>

                    <button
                        type="button"
                        className="btn btn-tertiary ml-2"
                        style={styles.mobileButton}
                        onClick={() => refine(facets)}
                    >
                        Reset
                    </button>
                </div>
            )}
        </div>
    );
};

const styles = {
    filterButton: {
        background: colors.primaryDark,
        border: 'none',
        borderRadius: '5px',
        color: colors.white,
        cursor: 'pointer',
        padding: '4px 8px',
    },
    filterButtonX: {
        marginTop: '1px',
    },
    clearAllButton: {
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    mobileButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1rem',
    },
    mobileButton: {
        padding: '0.5rem 1.0rem',
        width: 'auto',
    },
};

CurrentFilters.propTypes = {
    // Passed
    useButtons: PropTypes.bool,
    buttonClasses: PropTypes.string,
    clearAllClasses: PropTypes.string,
    onClose: PropTypes.func,

    // Algolia
    items: PropTypes.array.isRequired,
    refine: PropTypes.func.isRequired,
};

export default connectCurrentRefinements(CurrentFilters);
